(function() {
    'use strict';
    
    const videoPopup = {
        initVideoPopup: function () {
            const videoOpenPopup = document.querySelector(".video-open-popup");
            if (!videoOpenPopup) return;
            
            document.querySelectorAll('.video-open-popup .video-button').forEach(button => {
                button.addEventListener('click', function () {
                    const video_type = this.getAttribute('data-type');
                    const video_src = this.getAttribute('data-src');
                    const aspect_ratio = this.getAttribute('aspect_ratio');
                    const modal = document.querySelector('[data-popup-video]');
                    if (!modal) return;

                    const content = `<div class="fluid-width-video-wrapper" style="padding-top: ${aspect_ratio}">
                                        ${video_type == 'youtube' ?
                            `<iframe
                                                id="player"
                                                type="text/html"
                                                width="100%"
                                                frameborder="0"
                                                webkitAllowFullScreen
                                                mozallowfullscreen
                                                allowFullScreen
                                                src="https://www.youtube.com/embed/${video_src}?autoplay=1&mute=1">
                                            </iframe>`
                            :
                            `<iframe 
                                                src="https://player.vimeo.com/video/${video_src}?autoplay=1&mute=1" 
                                                class="js-vimeo" 
                                                allow="autoplay; 
                                                encrypted-media" 
                                                webkitallowfullscreen 
                                                mozallowfullscreen 
                                                allowfullscreen">
                                            </iframe>`
                        }
                                    </div>`;
                    const modalContent = modal.querySelector('.halo-popup-content');
                    if (modalContent) modalContent.innerHTML = content;
                    document.body.classList.add('video-show');
                });
            });

            document.querySelectorAll('[data-popup-video], [data-popup-video] .halo-popup-close, .background-overlay').forEach(element => {
                element.addEventListener('click', function (e) {
                    const modal = document.querySelector('[data-popup-video]');
                    if (!modal) return;
                    const modalContent = modal.querySelector('.halo-popup-content');
                    if (modalContent && !modalContent.contains(e.target)) {
                        document.body.classList.remove('video-show');
                        const iframe = modal.querySelector('iframe');
                        if (iframe) iframe.remove();
                    }
                });
            });
        },

        swapHoverVideoProductCard: function () {
            if (window.innerWidth > 1200) {
                document.querySelectorAll('.product-item .card:not(.has-first-video)').forEach(card => {
                    card.addEventListener('mouseenter', function () {
                        const video = this.querySelector('video');
                        if (video) {
                            video.play();
                        }
                    });
                    card.addEventListener('mouseleave', function () {
                        const video = this.querySelector('video');
                        if (video) {
                            video.pause();
                        }
                    });
                });
            }

            // Helper function to check if element is in viewport
            window.isInViewport = function (element) {
                const rect = element.getBoundingClientRect();
                const elementTop = rect.top + window.pageYOffset;
                const elementBottom = elementTop + element.offsetHeight;
                const viewportTop = window.pageYOffset;
                const viewportBottom = viewportTop + window.innerHeight;

                return elementBottom > viewportTop && elementTop < viewportBottom;
            };

            document.querySelectorAll(".product-item .card.has-first-video").forEach(card => {
                const video = card.querySelector('video');
                const firstImg = card.querySelector("img:first-child");
                const videoElement = video;

                const playVideoCard = () => {
                    if (firstImg) firstImg.style.opacity = "0";
                    if (videoElement) {
                        videoElement.style.opacity = "1";
                        videoElement.play();
                    }
                }

                const pauseVideoCard = () => {
                    if (videoElement) videoElement.pause();
                }

                if (window.isInViewport(card)) {
                    playVideoCard();
                } else {
                    pauseVideoCard();
                }

                const scrollHandler = () => {
                    if (window.isInViewport(card)) {
                        playVideoCard();
                    } else {
                        pauseVideoCard();
                    }
                };
                
                window.addEventListener('scroll', scrollHandler);
            });
        }
    };
    
    // Attach to window.halo
    if (!window.halo) {
        window.halo = {};
    }
    
    // Attach all video popup functions to halo
    Object.assign(window.halo, videoPopup);
    
    // Auto-initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            videoPopup.initVideoPopup();
            videoPopup.swapHoverVideoProductCard();
        });
    } else {
        videoPopup.initVideoPopup();
        videoPopup.swapHoverVideoProductCard();
    }
})();









